export function getTimeZone() {
  try {
    var intl = new Intl.DateTimeFormat();
    return intl.resolvedOptions().timeZone;
  } catch (_a) {
    return undefined;
  }
}